import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "container-fluid admin-auth" };
const _hoisted_2 = { class: "row min-vh-100 align-items-center justify-content-center" };
const _hoisted_3 = { class: "col-md-6 col-lg-4" };
const _hoisted_4 = { class: "card auth-card" };
const _hoisted_5 = { class: "card-body p-5" };
const _hoisted_6 = { class: "mb-3" };
const _hoisted_7 = { class: "input-group" };
const _hoisted_8 = ["disabled"];
const _hoisted_9 = { class: "mb-4" };
const _hoisted_10 = { class: "input-group" };
const _hoisted_11 = ["disabled"];
const _hoisted_12 = {
    key: 0,
    class: "alert alert-danger mb-3"
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
    key: 0,
    class: "fas fa-spinner fa-spin me-2"
};
const _hoisted_15 = {
    key: 1,
    class: "fas fa-sign-in-alt me-2"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/store/auth';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminLogin',
    setup(__props) {
        const router = useRouter();
        const authStore = useAuthStore();
        const email = ref('');
        const password = ref('');
        // Verificar autenticación al montar el componente
        onMounted(() => {
            authStore.checkAuth();
            // Si ya está autenticado, redirigir
            if (authStore.authenticated) {
                router.push('/admin');
            }
        });
        const handleLogin = async () => {
            if (await authStore.login(email.value, password.value)) {
                router.push('/admin');
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-center mb-4" }, [
                                    _createElementVNode("i", { class: "fas fa-shield-alt display-4 mb-3 auth-icon" }),
                                    _createElementVNode("h2", { class: "fw-bold auth-title" }, "Admin Panel"),
                                    _createElementVNode("p", { class: "auth-subtitle" }, "Bolivia Turismo")
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(handleLogin, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _cache[3] || (_cache[3] = _createElementVNode("label", {
                                            for: "email",
                                            class: "form-label"
                                        }, "Email", -1)),
                                        _createElementVNode("div", _hoisted_7, [
                                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "input-group-text" }, [
                                                _createElementVNode("i", { class: "fas fa-envelope" })
                                            ], -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "email",
                                                class: "form-control",
                                                id: "email",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                                                placeholder: "Correo",
                                                required: "",
                                                disabled: _unref(authStore).loading
                                            }, null, 8, _hoisted_8), [
                                                [_vModelText, email.value]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _cache[5] || (_cache[5] = _createElementVNode("label", {
                                            for: "password",
                                            class: "form-label"
                                        }, "Contraseña", -1)),
                                        _createElementVNode("div", _hoisted_10, [
                                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "input-group-text" }, [
                                                _createElementVNode("i", { class: "fas fa-lock" })
                                            ], -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "password",
                                                class: "form-control",
                                                id: "password",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((password).value = $event)),
                                                placeholder: "••••••••",
                                                required: "",
                                                disabled: _unref(authStore).loading
                                            }, null, 8, _hoisted_11), [
                                                [_vModelText, password.value]
                                            ])
                                        ])
                                    ]),
                                    (_unref(authStore).error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_unref(authStore).error), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-primary w-100 mb-3 auth-btn",
                                        disabled: _unref(authStore).loading
                                    }, [
                                        (_unref(authStore).loading)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                                            : (_openBlock(), _createElementBlock("i", _hoisted_15)),
                                        _createTextVNode(" " + _toDisplayString(_unref(authStore).loading ? 'Iniciando sesión...' : 'Iniciar Sesión'), 1)
                                    ], 8, _hoisted_13)
                                ], 32)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
